/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
} from 'antd';
import CurrencyInput from 'components/CurrencyInput';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { onAlert } from 'utils/handlers';
import { getNombramiento } from 'api/catalogos/Nombramientos';
import { getDatoOperacionalesDeHonorariosAsimilados } from 'api/estructuraOrganizacional/datosOperacionalesDeHonorarioAsimilado';
import { getPlazavistaOptimized } from 'api/catalogos/plazas';
import Select from 'components/Select';

// eslint-disable-next-line react/prop-types
const HonorarioAsimiladoAtributos = ({
  form,
  tipodeActividades,
  tiposDeContrataciones,
  jornadas,
  tiposDeSueldos,
  sindicatos,
  perioricidadesDePago,
  zonasDeSalariosMinimos,
  tiposRegimenesNominas,
  tiposDeNominasEmpleados,
  rules,
  isBlocked,
  caracteresDeNombramiento = [],
  empleado,
  nombramientosSinPaginar,
  plazaEmpleado,
  tiposEmpleados,
  tiemposDeContrataciones,
  tiposOrigenesContratacion,
  origenContratacionSeleccionado,
}) => {
  const [, setAplicaFirma] = useState(false);
  const [sindicalizado, setSindicalizado] = useState(false);

  useEffect(() => {
    const toMoment = (val) => (val ? moment(val) : null);

    const fetch = async () => {
      try {
        if (!form || !empleado) return;

        const datosOp = await getDatoOperacionalesDeHonorariosAsimilados({ honorario_asimilado: empleado });
        if (!datosOp?.length) return;

        const dato = datosOp[0];

        // === 1. Nombramiento ===
        if (dato.nombramiento) {
          const nombramiento = await getNombramiento(dato.nombramiento);
          if (nombramiento) {
            form.setFieldsValue({
              tipo_de_nombramiento: nombramiento.descripcion_caracter_de_nombramiento,
              folio_de_nombramiento: nombramiento.folio,
              vigencia_de_nombramiento_inicio: toMoment(nombramiento.inicio_vigencia),
              vigencia_de_nombramiento_fin: toMoment(nombramiento.termino_de_vigencia),
              sueldo_mensual: nombramiento.sueldo_mensual,
              sueldo_diario: nombramiento.sueldo_mensual
                ? (nombramiento.sueldo_mensual / 30).toFixed(2)
                : null,
            });
          }
        }

        // === 2. Plaza ===
        if (dato.plaza) {
          const plaza = await getPlazavistaOptimized(dato.plaza);
          if (plaza) {
            form.setFieldsValue({
              tipo_empleado: plaza.tipo_de_empleado,
              categoria: plaza.categoria_de_empleado,
              tipo_de_contratacion: plaza.tipo_de_contratacion_descripcion,
              tipo_de_actividad: plaza.tipo_de_actividad_id,
              clase_de_contratacion: plaza.clase_de_contratacion,
              tiempo_de_contratacion: plaza.tiempo_de_contratacion,
              tipo_de_nomina_empleado: plaza.tipo_nomina_empleado,
              tipo_regimen_nomina: plaza.tipo_de_regimen_nomina,
              zonasDeSalariosMinimos: plaza.zona_de_salario_minimo_descripcion,
            });
          }
        }

        // === 3. Jornada (si ya hay jornada en el form) ===
        const jornadaId = form.getFieldValue('jornada');
        const jornadaSeleccionada = jornadas.find((j) => j.id === jornadaId);

        if (jornadaSeleccionada) {
          const horarioFormateado = `De ${jornadaSeleccionada.rango_hora_inicial.slice(0, 5)} A ${jornadaSeleccionada.rango_hora_final.slice(0, 5)}`;
          form.setFieldsValue({
            horario: horarioFormateado,
            numero_horas_semanales: jornadaSeleccionada.horas_desde,
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[Atributos del Honorario Asimilado] error al cargar datos operacionales/plaza', error);
      }
    };

    fetch();
  }, [empleado, form, jornadas]);

  useEffect(() => {
    if (tiposOrigenesContratacion?.length > 0 && origenContratacionSeleccionado) {
      const match = tiposOrigenesContratacion.find(
        (item) => item.id === origenContratacionSeleccionado,
      );
      form.setFieldsValue({
        tipo_de_origen_de_contratacion: match ? match.descripcion : 'No especificado',
      });
    } else {
      form.setFieldsValue({ tipo_de_origen_de_contratacion: '' });
    }
  }, [tiposOrigenesContratacion, origenContratacionSeleccionado, form]);

  return (
    <Form layout="vertical" form={form} scrollToFirstError name="general">
      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="1. Contratación"
        extra="Tipo, Tiempo, Nómina Y Origen"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tipo_de_origen_de_contratacion"
              label="Tipo de Origen de Contratación"
              hasFeedback
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tipo_empleado"
              label="Tipo de Empleado"
              // rules={rules.required}
              hasFeedback
            >
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={tiposEmpleados}
                disabled
              />
            </Form.Item>
          </Col>

          {/* //? Hay un catalogo? */}
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="categoria"
              label="Categoria de Empleado"
              // rules={rules.required}
              hasFeedback
            >
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={[]}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tiempo_de_contratacion"
              label="Tiempo de Contratación"
              // rules={rules.required}
              hasFeedback
            >
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={tiemposDeContrataciones}
                disabled
              />
            </Form.Item>
          </Col>
          {/* //? Hay un catalogo? */}
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="clase_de_contratacion"
              label="Clase de Contratacion"
              // rules={rules.required}
              hasFeedback
            >
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={[]}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tipo_de_contratacion"
              label="Tipo de Contratación"
              hasFeedback
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="tipo_de_nomina_empleado" label="Tipo de Nómina Empleado" hasFeedback>
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={tiposDeNominasEmpleados}
                onChange={(value) => {
                  const tipo = tiposDeNominasEmpleados.find((e) => e.id === value);
                  if (tipo?.habilitado) {
                    form.setFieldValue('periodicidad_de_pago', tipo.periodicidad_de_pago);
                  } else {
                    onAlert(`El Tipo de Nómina Empleado ${tipo?.descripcion} se encuentra cerrado`);
                    form.resetFields(['tipo_de_nomina_empleado']);
                  }
                }}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tipo_de_actividad"
              label="Tipo de Actividad"
              hasFeedback
            >
              <Select
                labelProp="concepto"
                keyProp="id"
                dataSource={tipodeActividades}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="2. Régimen Fiscal Y Sueldo"
        extra="SAT, Tipo De Sueldo, Periodicidad Y Zona"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={24}>
            <Form.Item name="tipo_regimen_nomina" label="Tipo de Régimen del SAT" hasFeedback>
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={tiposRegimenesNominas}
                render={(val) => `${val?.clave} - ${val?.descripcion}`}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="tipo_de_sueldo" label="Tipo de Sueldo" hasFeedback>
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={tiposDeSueldos}
                disabled
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={8}>
            <Form.Item name="periodicidad_de_pago" label="Periodicidad de Pago" hasFeedback>
              <Select labelProp="descripcion" keyProp="id" dataSource={perioricidadesDePago} disabled />
            </Form.Item>
            {' '}
          </Col>

          <Col xs={24} sm={24} md={8}>
            <Form.Item name="zona_de_salario_minimo" label="Zona de Salario Mínimo" hasFeedback>
              <Select labelProp="descripcion" keyProp="id" dataSource={zonasDeSalariosMinimos} disabled />
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="3. Nombramiento"
        extra="Tipo, Folio Y Vigencia"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="tipo_de_nombramiento" label="Tipo de Nombramiento">
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={caracteresDeNombramiento}
                onChange={(value) => {
                  const caracter = caracteresDeNombramiento.find((c) => c.id === value);
                  form.setFieldsValue({
                    folio_de_nombramiento: `FOLIO-${value}`,
                    vigencia_de_nombramiento_inicio: moment(caracter?.vigencia_inicial),
                    vigencia_de_nombramiento_fin: caracter?.vigencia_final ? moment(caracter.vigencia_final) : null,
                  });
                }}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="folio_de_nombramiento" label="Folio de Nombramiento">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="Vigencia de Nombramiento">
              <Input.Group compact>
                <Form.Item name="vigencia_de_nombramiento_inicio" noStyle>
                  <DatePicker
                    format="DD/MM/YYYY"
                    disabled
                    style={{ width: '50%' }}
                  />
                </Form.Item>
                <Form.Item name="vigencia_de_nombramiento_fin" noStyle>
                  <DatePicker format="DD/MM/YYYY" disabled style={{ width: '50%' }} />
                </Form.Item>
              </Input.Group>
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="4. Jornada Y Asistencia"
        extra="Horario, Horas Semanales Y Checador"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="jornada" label="Jornada" hasFeedback>
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={jornadas}
                onChange={(value) => {
                  const jornadaSeleccionada = jornadas.find((j) => j.id === value);

                  if (jornadaSeleccionada) {
                    const horarioFormateado = `De ${jornadaSeleccionada.rango_hora_inicial.slice(0, 5)} A ${jornadaSeleccionada.rango_hora_final.slice(0, 5)}`;

                    form.setFieldsValue({
                      horario: horarioFormateado,
                      numero_horas_semanales: jornadaSeleccionada.horas_desde,
                    });
                  }
                }}
                disabled
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={8}>
            <Form.Item name="horario" label="Horario" hasFeedback>
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={8}>
            <Form.Item name="numero_horas_semanales" label="Número de Horas Semanal">
              <InputNumber disabled style={{ width: '100%' }} />
            </Form.Item>
          </Col>

          {/* //? Falta el campo en la plaza */}
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="vigencia_del_horario" label="Vigencia del Horario">
              <DatePicker
                format="DD/MM/YYYY"
                disabled
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="aplica_reloj_checador" label="Aplica Reloj Checador">
              <Select trueFalse disabled />
            </Form.Item>
          </Col>

          {/* //? Hay un catalogo? */}
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="tipo_checado" label="Tipo de Checado">
              <Select disabled />
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="5. Sindicato"
        extra="Afiliación Sindical Del Honorario Asimilado"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={12}>
            <Form.Item name="sindicalizado" label="Sindicalizado" hasFeedback initialValue={false}>
              <Select
                trueFalse
                onChange={(value) => {
                  setSindicalizado(value);
                  if (!value) {
                    form.resetFields(['sindicato']);
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item name="sindicato" label="Sindicato" rules={sindicalizado ? rules.required : null} hasFeedback>
              <Select labelProp="descripcion" keyProp="id" dataSource={sindicatos} disabled={!sindicalizado} />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Form>
  );
};

export default HonorarioAsimiladoAtributos;
